export const SERVICES_TAB = 'services';
export const CATEGORIES_TAB = 'categories';
export const PACKAGES_TAB = 'packages';
export const CUSTOMER_PACKAGES_TAB = 'customer-packages';
export const COMBOS_TAB = 'combos';
export const CONSENT_FORMS_TAB = 'consent-forms';

export const resolveActiveTab = (
  tabParam,
  canReadPackages,
  canReadConsentForms,
  canReadCombos,
  allowsServicePackages,
  allowsConsentForms,
  allowsServiceCombos,
) => {
  if (tabParam === CATEGORIES_TAB) {
    return CATEGORIES_TAB;
  }

  if (tabParam === COMBOS_TAB && canReadCombos && allowsServiceCombos) {
    return COMBOS_TAB;
  }

  if ((tabParam === PACKAGES_TAB || tabParam === CUSTOMER_PACKAGES_TAB) && canReadPackages && allowsServicePackages) {
    return tabParam;
  }

  if (tabParam === CONSENT_FORMS_TAB && canReadConsentForms && allowsConsentForms) {
    return CONSENT_FORMS_TAB;
  }

  return SERVICES_TAB;
};
